import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-7" }
const _hoisted_6 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 2,
  class: "dropdown d-inline"
}
const _hoisted_10 = {
  class: "dropdown-menu p-3 shadow-sm",
  style: {"width":"400px"}
}
const _hoisted_11 = { class: "form-group form-check" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "badge badge-info",
  title: "Service Account"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "alert alert-info mt-3",
  role: "alert"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "fg-color-red" }
const _hoisted_22 = {
  key: 0,
  class: "badge badge-info ml-2"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 1,
  class: "text-muted mt-2"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "container" }
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    import { useCurrentUserQueryV1, useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useWorkspacesByUserQueryV1 } from '@Organizations/Workspaces/queries-vue-composables'
    
    import
        {
            useLockUserCommandV1,
            useUnlockUserCommandV1,
            useResetPasswordCommandV1,
            useSignoutFromAllSessionsCommandV1,
            useDisableUserCommandV1,
            useEnableUserCommandV1,
            useAcceptUserAccessRequestCommandV1,
            useRejectUserAccessRequestCommandV1
        } from '@Organizations/Users/commands-vue-composables'

    // ---------------- router ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const id = computed(() => String(route.params.id))

    // ---------------- local state ----------------

    const sendPasswordToEmailEnabled = ref(false)
    const sendPasswordToEmail = ref<string | null>(null)

    // ---------------- queries ----------------

    const { runCurrentUserQueryV1,
        authorized }
        = useCurrentUserQueryV1(false, true, false)

    const {
        runUserQueryV1,
        modelUserQueryV1: user
    } = useUserQueryV1(id)

    const {
        runWorkspacesByUserQueryV1,
        modelWorkspacesByUserQueryV1: userWorkspaces
    } = useWorkspacesByUserQueryV1(id)

    // ---------------- derived ----------------

    const email = computed(() => user.value?.Email)
    const displayName = computed(() => user.value?.DisplayName)
    const isServiceUser = computed(() => user.value?.IsServiceUser ?? false)
    const userType = computed(() => user.value?.IsGlobalAdmin ? 'Global Admin' : 'User')

    const isLocked = computed(() => user.value?.IsLocked)
    const isDeleted = computed(() => user.value?.IsDeleted)
    const isRequested = computed(() => user.value?.IsRequested)
    const isAccepted = computed(() => user.value?.IsAccepted)
    const isRejected = computed(() => user.value?.IsRejected)

    const requestedBy = computed(() => user.value?.RequestedBy)
    const organizationUnitId = computed(() => user.value?.OrganizationUnitId)

    const workspaces = computed(() => userWorkspaces.value?.Workspaces ?? [])

    // ---------------- watch local flags ----------------

    watch(sendPasswordToEmailEnabled, enabled =>
    {
        if (!enabled)
        {
            sendPasswordToEmail.value = null
        }
    })

    // ---------------- commands ----------------

    const { invokeLockUserCommandV1, succeedLockUserCommandV1, errorLockUserCommandV1 } = useLockUserCommandV1(id)
    const { invokeUnlockUserCommandV1, succeedUnlockUserCommandV1, errorUnlockUserCommandV1 } = useUnlockUserCommandV1(id)
    const { invokeResetPasswordCommandV1, succeedResetPasswordCommandV1, errorResetPasswordCommandV1 } = useResetPasswordCommandV1(id, sendPasswordToEmail)
    const { invokeSignoutFromAllSessionsCommandV1, succeedSignoutFromAllSessionsCommandV1, errorSignoutFromAllSessionsCommandV1 } = useSignoutFromAllSessionsCommandV1(id)
    const { invokeDisableUserCommandV1, succeedDisableUserCommandV1, errorDisableUserCommandV1 } = useDisableUserCommandV1(id)
    const { invokeEnableUserCommandV1, succeedEnableUserCommandV1, errorEnableUserCommandV1 } = useEnableUserCommandV1(id)
    const { invokeAcceptUserAccessRequestCommandV1, succeedAcceptUserAccessRequestCommandV1, errorAcceptUserAccessRequestCommandV1 } = useAcceptUserAccessRequestCommandV1(id)
    const { invokeRejectUserAccessRequestCommandV1, succeedRejectUserAccessRequestCommandV1, errorRejectUserAccessRequestCommandV1 } = useRejectUserAccessRequestCommandV1(id)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Manage user'
        runCurrentUserQueryV1()
        runUserQueryV1()
        runWorkspacesByUserQueryV1()
    })

    watch(succeedAcceptUserAccessRequestCommandV1, (succeeded) => {
        if (succeeded) {
             router.push(`/admin/organizations/users/requests/${organizationUnitId.value}`)
        }
    })

    watch(succeedRejectUserAccessRequestCommandV1, (succeeded) => {
        if (succeeded) {
             router.push(`/admin/organizations/users/requests/${organizationUnitId.value}`)
        }
    })

    //watch(authorized, () =>
    //{
    //    if (authorized.value === false)
    //    {
    //        location.href = '/#/signin';
    //    }
    //})

    watch(
    [
        succeedLockUserCommandV1,
        succeedUnlockUserCommandV1,
        succeedDisableUserCommandV1,
        succeedEnableUserCommandV1,
        succeedResetPasswordCommandV1,
        succeedSignoutFromAllSessionsCommandV1
    ],
    (states) => {
        if (states.some(Boolean)) {
            runUserQueryV1()
        }
    })

    watch(
    [
        errorLockUserCommandV1,
        errorUnlockUserCommandV1,
        errorDisableUserCommandV1,
        errorEnableUserCommandV1,
        errorResetPasswordCommandV1,
        errorSignoutFromAllSessionsCommandV1,
        errorRejectUserAccessRequestCommandV1,
        errorAcceptUserAccessRequestCommandV1
    ],
    (errors) => {
        const error = errors.find(e => !!e)

        if (error) {
            alert(error);
        }
    })

    function handleLockUserCommandV1()
    {
        const type = isServiceUser.value ? 'service account' : 'user'
        if (window.confirm(`Do you really want to lock ${type} ${email.value}?`))
        {
            invokeLockUserCommandV1()
        }
    }

    function handleUnlockUserCommandV1()
    {
        const type = isServiceUser.value ? 'service account' : 'user'
        if (window.confirm(`Do you really want to unlock ${type} ${email.value}?`))
        {
            invokeUnlockUserCommandV1()
        }
    }

    function handleResetPasswordCommandV1()
    {
        if (window.confirm(`Do you really want to reset password for user ${email.value}?`))
        {
            invokeResetPasswordCommandV1()
        }
    }

    function handleSignoutFromAllSessionsCommandV1()
    {
        if (window.confirm(`Do you really want to revoke all sessions for user ${email.value}?`))
        {
            invokeSignoutFromAllSessionsCommandV1()
        }
    }

    function handleDisableUserCommandV1()
    {
        const type = isServiceUser.value ? 'service account' : 'user'
        if (window.confirm(`Do you really want to delete ${type} ${email.value}?`))
        {
            invokeDisableUserCommandV1()
        }
    }

    function handleEnableUserCommandV1()
    {
        const type = isServiceUser.value ? 'service account' : 'user'
        if (window.confirm(`Do you really want to restore ${type} ${email.value}?`))
        {
            invokeEnableUserCommandV1()
        }
    }

    function handleAcceptUserAccessRequestCommandV1()
    {
        if (window.confirm(`Do you really want to accept user access request for ${email.value}?`))
        {
            invokeAcceptUserAccessRequestCommandV1()
        }
    }

    function handleRejectUserAccessRequestCommandV1()
    {
        if (window.confirm(`Do you really want to reject user access request for ${email.value}?`))
        {
            invokeRejectUserAccessRequestCommandV1()
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (organizationUnitId.value)
        ? (_openBlock(), _createBlock(AdminNavigationV2, {
            key: 0,
            tid: organizationUnitId.value
          }, null, 8 /* PROPS */, ["tid"]))
        : _createCommentVNode("v-if", true)
    ]),
    (isAccepted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(isServiceUser.value ? 'Manage service account' : 'Manage user'), 1 /* TEXT */),
                (!isDeleted.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("a", {
                        href: `/#/admin/organizations/users/manage/details/${id.value}`,
                        class: "btn btn-link btn-sm"
                      }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("i", {
                          class: "fa fa-pencil",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */),
                        _createTextVNode(" Edit ", -1 /* CACHED */)
                      ]))], 8 /* PROPS */, _hoisted_8),
                      (isLocked.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleUnlockUserCommandV1,
                            class: "btn btn-link btn-sm"
                          }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("i", {
                              class: "fa fa-unlock-alt",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" Unlock ", -1 /* CACHED */)
                          ]))]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: handleLockUserCommandV1,
                            class: "btn btn-link btn-sm"
                          }, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("i", {
                              class: "fa fa-lock",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" Lock ", -1 /* CACHED */)
                          ]))])),
                      _createCommentVNode(" Password reset only for regular users, not service accounts "),
                      (!isServiceUser.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[9] || (_cache[9] = _createElementVNode("button", {
                              class: "btn btn-link",
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createElementVNode("i", {
                                class: "fa fa-key",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" Reset password ")
                            ], -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("button", {
                                onClick: handleResetPasswordCommandV1,
                                class: "btn btn-secondary"
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", {
                                  class: "fa fa-key",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */),
                                _createTextVNode(" Reset password ", -1 /* CACHED */)
                              ]))]),
                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sendPasswordToEmailEnabled).value = $event)),
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: "sendPasswordOnEmail"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelCheckbox, sendPasswordToEmailEnabled.value]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: "sendPasswordOnEmail"
                                }, "Send password on additional email", -1 /* CACHED */))
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sendPasswordToEmail).value = $event)),
                                type: "email",
                                class: "form-control",
                                placeholder: "Email"
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, sendPasswordToEmail.value],
                                [_vShow, sendPasswordToEmailEnabled.value]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" API key management for service accounts "),
                      (isServiceUser.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            href: `/#/organizations/accesstokens/manage/${id.value}`,
                            class: "btn btn-link btn-sm"
                          }, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("i", {
                              class: "fa fa-key",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" Manage API keys ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_12))
                        : _createCommentVNode("v-if", true),
                      (!isServiceUser.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            onClick: handleSignoutFromAllSessionsCommandV1,
                            class: "btn btn-link btn-sm"
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", {
                              class: "fa fa-ban",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" Revoke sessions ", -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        onClick: handleDisableUserCommandV1,
                        class: "btn btn-link btn-sm"
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("i", {
                          class: "fa fa-remove",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */),
                        _createTextVNode(" Delete ", -1 /* CACHED */)
                      ]))])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: handleEnableUserCommandV1,
                        class: "btn btn-link btn-sm"
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", {
                          class: "fa fa-undo",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(isServiceUser.value ? 'Restore service account' : 'Restore user'), 1 /* TEXT */)
                      ])
                    ]))
              ])
            ])
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_14, [
            (!isDeleted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("h3", null, _toDisplayString(displayName.value), 1 /* TEXT */),
                  _createElementVNode("h6", null, _toDisplayString(email.value), 1 /* TEXT */),
                  _createElementVNode("h6", null, [
                    (isServiceUser.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Service Account"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(userType.value), 1 /* TEXT */))
                  ]),
                  _createCommentVNode(" Informational alert for service accounts "),
                  (isServiceUser.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", {
                          class: "fa fa-info-circle",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */),
                        _createElementVNode("strong", null, "Service Account:", -1 /* CACHED */),
                        _createTextVNode(" This account is used for API access and automation. It cannot sign in through the web UI and uses API keys for authentication. ", -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" Manage roles button for all users (including service accounts) "),
                  _createElementVNode("a", {
                    href: `/#/admin/organizations/users/manage/roles/${id.value}`,
                    class: "btn btn-secondary btn-sm"
                  }, " Manage roles ", 8 /* PROPS */, _hoisted_19)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h3", _hoisted_21, [
                    _createTextVNode(_toDisplayString(displayName.value) + " is deleted ", 1 /* TEXT */),
                    (isServiceUser.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Service Account"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("h6", null, _toDisplayString(email.value), 1 /* TEXT */)
                ])),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createCommentVNode(" Workspaces section for all users (including service accounts) "),
            (!isDeleted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[16] || (_cache[16] = _createElementVNode("h4", null, "Workspaces", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (w) => {
                    return (_openBlock(), _createElementBlock("h6", null, _toDisplayString(w.Name), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  (workspaces.value.length==0)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_24, "No workspaces assigned"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("a", {
                    href: `/#/admin/organizations/users/manage/workspaces/${id.value}`,
                    class: "btn btn-secondary btn-sm"
                  }, " Manage workspaces ", 8 /* PROPS */, _hoisted_25),
                  (isServiceUser.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("small", null, [
                          _createElementVNode("i", { class: "fa fa-info-circle" }),
                          _createTextVNode(" Service accounts can have workspace access for API operations.")
                        ], -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : (isRequested.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage user access request</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("h3", null, _toDisplayString(displayName.value), 1 /* TEXT */),
              (displayName.value != email.value)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_29, _toDisplayString(email.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (requestedBy.value)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_30, "Requested by " + _toDisplayString(requestedBy.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: handleAcceptUserAccessRequestCommandV1,
                class: "btn btn-lg btn-success mr-1"
              }, "Accept"),
              _createElementVNode("button", {
                onClick: handleRejectUserAccessRequestCommandV1,
                class: "btn btn-lg btn-danger"
              }, "Reject")
            ])
          ]))
        : (isRejected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage user access request</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h3", _hoisted_33, "Rejected user access for " + _toDisplayString(displayName.value), 1 /* TEXT */),
                (displayName.value != email.value)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_34, _toDisplayString(email.value), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (requestedBy.value)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_35, "Requested by " + _toDisplayString(requestedBy.value), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  onClick: handleAcceptUserAccessRequestCommandV1,
                  class: "btn btn-lg btn-success"
                }, "Accept")
              ])
            ]))
          : _createCommentVNode("v-if", true)
  ]))
}
}

})